<template>
  <div
    class="page-header align-items-start min-vh-100"
    style="background-color: transparent"
  >
    <span class="mask opacity-6"></span>
    <div class="container my-auto">
      <div class="row">
        <div class="col-lg-4 col-md-8 col-12 mx-auto">
          <div class="card z-index-0 fadeIn3 fadeInBottom">
            <div class="card-body">
              <img
                src="@/assets/img/logo.png"
                style="width: 40%; display: block; margin: 0 auto"
                alt=""
              />

              <form role="form" class="text-start mt-3">
                <h5 style="text-align: center">Alteração de senha</h5>
                <div>
                  <div
                    class="input-group input-group-outline m-0 d-flex flex-column"
                  >
                    <label class="input-label">
                      <span
                        class="text-xs text-uppercase text-body font-weight-bolder"
                        >Nova Senha</span
                      >
                      <input
                        v-model="password"
                        type="password"
                        class="form-control default-bordered-input"
                        placeholder="Nova senha"
                        @keyup.enter="auth"
                      />
                    </label>
                  </div>

                  <div
                    class="input-group input-group-outline m-0 d-flex flex-column"
                  >
                    <label class="input-label">
                      <span
                        class="text-xs text-uppercase text-body font-weight-bolder"
                        >Confirme a Nova Senha</span
                      >
                      <input
                        v-model="confirmPassword"
                        type="password"
                        class="form-control default-bordered-input"
                        placeholder="Confirme a nova senha"
                        @keyup.enter="auth"
                      />
                    </label>
                  </div>
                </div>

                <div class="text-center">
                  <button
                    class="btn btn-icon btn-3 campaign-btn m-0"
                    type="button"
                    disabled
                    v-if="loading"
                  >
                    <span class="btn-inner--text btn-text">Aguarde...</span>
                  </button>
                  <button
                    class="btn btn-icon btn-3 campaign-btn m-0"
                    type="button"
                    @click.prevent="resetPassword"
                    v-if="!loading"
                  >
                    <span class="btn-inner--text btn-text">Alterar Senha</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoggingMixin from "@/mixins/LoggingMixin.js";

import AuthHttp from "@/http/AuthHttp.js";

import { mapMutations } from "vuex";

export default {
  name: "nova-senha",
  mixins: [LoggingMixin],
  data() {
    return {
      loading: false,
      password: "",
      confirmPassword: "",
    };
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  mounted() {
    this.verifyToken();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    async handleInputValue(event) {
      const { name, value } = event.target;
      this[name] = value;
    },
    async verifyToken() {
      const token = this.$route.params.token;

      if (token) {
        try {
          const response = await AuthHttp.validateUser(token);

          if (response.data.status == 401) {
            this.$router.push("/sign-in");
          }
        } catch (error) {
          this.$toast.add({
            severity: "error",
            summary: "Houve um erro!",
            detail: "O token informado é inválido!",
            life: 3000,
          });
          this.$router.push("/sign-in");
          console.error(error);
        }
      } else {
        this.$router.push("/sign-in");
      }
    },
    async resetPassword() {
      if (this.password != this.confirmPassword) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção!",
          detail: "As senhas não conferem!",
          life: 3000,
        });
        return;
      }

      if (this.password.trim() == "" || this.confirmPassword.trim() == "") {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção!",
          detail: "Preencha ambos os campos e tente novamente!",
          life: 3000,
        });
        return;
      }

      this.loading = true;

      const token = this.$route.params.token;

      try {
        await AuthHttp.resetPassword(token, {
          password: this.password,
        });

        this.$log.log("AUTH", "AÇÃO", `Senha resetada com sucesso - Token: ${token}`);
        this.$toast.add({
          severity: "success",
          summary: "Sucesso!",
          detail: "Sua senha foi alterada com sucesso!",
          life: 3000,
        });

        this.$router.push("/sign-in");
      } catch (error) {
        this.$log.logError(
          `Erro ao resetar senha: ${error.message || error.error || 'Erro desconhecido'} - Token: ${token}`,
          "ResetPassword"
        );
        this.$toast.add({
          severity: "error",
          summary: "Houve um erro!",
          detail:
            "Algo de errado aconteceu ao tentar alterar sua senha... tente novamente em instantes.",
          life: 3000,
        });
        console.error(error);
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.campaign-btn {
  color: #ffffff;
  background-color: #e41b80;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;
  height: 40px;
  width: 100%;
  margin-top: 15px !important;

  .btn-icon {
    font-size: 1.6em;
  }

  &:hover {
    color: #ffffff;
  }
}

.more-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
}

.no-campaign {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;
  padding: 50px 0;
}
</style>
